<i18n>
{
  "en": {
    "title": "Company Values & Sustainability 2017-2018",
    "description": "Our employees are motivated by our ambition to provide access to energy for everyone around the world. Learn about the shared set of company values to drive progress, as well as our Employer Value Proposition, and our OneVoice survey, where employees regularly share their input to keep the company moving forward.",
    "ourPeople": {
      "companyValues": {
        "hero": {
          "title": "Company Values"
        },
        "txt1": {
          "h2-1": "Company Values",
          "p-1": "At Schneider Electric, we're committed to the global ambition that we serve, and each of us believes in our purpose. Ensuring access to energy for everyone around the world motivates and energizes every single employee. As such, we share a set of values that we sustain as part of an ongoing effort to change the status quo.",

          "h2-2": "Who we are and what we do:",
          "h3-1": "Straightforward",
          "p-2": "We do what we say and we communicate in simple ways. We behave with integrity.",

          "h3-2": "Challenge",
          "p-3": "We challenge ourselves and others to rethink what is expected. We are agile and move at the speed of change.",

          "h3-3": "Open",
          "p-4": "We value differences. We listen. We learn, connect, and collaborate with others.",

          "h3-4": "Passionate",
          "p-5": "We are passionate about our customers, our people, our business, and our technology. We are positive in our approach to finding solutions that improve lives.",

          "h3-5": "Effective",
          "p-6": "We deliver on promises. We are pragmatic and fast, and we compete to win.",
          "p-7": "Holding ourselves and each other to these standards on a daily basis, we become more innovative, gain more momentum, and become better equipped to exceed customer expectations."
        },
        "txt2": {
          "h2": "Why working here matters",
          "p": "At Schneider Electric, our Employer Value Proposition (EVP) is our way of telling the world what it means to be part of this organization. As a progressive company, we believe it is our responsibility to set each employee up for success, and provide them with the tools they need to reach their full potential. This is outlined in our EVP, our cornerstone: “Great people make Schneider Electric a great company.” It includes four key attributes that evolve annually along with us. Our EVP helps us change the game with award-winning talent to whom we provide equal opportunities, trust, and empowerment for innovation and high performance."
        },
        "table1": {
          "h2": "Great people make Schneider Electric a great company",
          "c1": "Our belief is that access to energy is a basic human right.",
          "c1-2": "We are committed to a sustainable future by solving the energy paradox.",
          "c2": "We provide opportunities to everyone everywhere.",
          "c2-2": "We ensure all employees feel uniquely valued and safe to contribute their best.",
          "c3": "We lead the Digital Transformation.",
          "c3-2": "We collaborate with the largest partner, integrator, and development ecosystem on our open platform.",
          "c4": "We are ambitious for customer, and our business growth.",
          "c4-2": "We like to win as a team. We empower and trust our people to stay agile."
        },
        "txt3": {
          "h2": "Our voice is OneVoice",
          "p": "To feel heard is to feel respected. At Schneider Electric, we don’t assume we know what our employees are thinking, or what’s best for them — we ask them, twice a year, every year. We can’t expect to thrive without their honest input, and that is where the OneVoice satisfaction survey comes in. Managed by an independent polling firm, it provides a detailed view of employee satisfaction, and keeps us moving forward as a unified force."
        },
        "snapshot": {
          "title": "Our OneVoice survey in numbers by end of 2017",
          "c1h4": "100%",
          "c1p1": "of employees",
          "c1p2": "surveyed twice a year",

          "c2h4": "179,000",
          "c2p1": "emails sent",

          "c3h4": "78,000",
          "c3p1": "people",
          "c3p2": "reached via kiosks on 271 production sites",

          "c4h4": "3,300",
          "c4p1": "managers",
          "c4p2": "received a dedicated report",

          "c5h4": "80%",
          "c5unit": "participation rate",
          "c5p1": "in 2017, improved from 62% in 2011"
        },
        "barometer": {
          "h2": "2015 – 2017 Planet <span class='t-nowrap'>&amp; Society</span> barometer achievement",
          "cb1": "Health &amp; Equity",
          "h4": "65%",
          "cb2": "was our score in the Employee Engagement Index",
          "cta": "See the full results"
        }
      }
    }
  },
  "fr": {
    "title": "Company Values & Sustainability 2017-2018",
    "description": "Our employees are motivated by our ambition to provide access to energy for everyone around the world. Learn about the shared set of company values to drive progress, as well as our Employer Value Proposition, and our OneVoice survey, where employees regularly share their input to keep the company moving forward.",
    "ourPeople": {
      "companyValues": {
        "hero": {
          "title": "Les valeurs de notre entreprise"
        },
        "txt1": {
          "h2-1": "Les valeurs de notre entreprise",
          "p-1": "Chez Schneider Electric, nous sommes engagés en faveur de l’ambition globale que nous portons, et chacune et chacun d’entre nous adhère à cette vision. Garantir à chaque individu dans le monde l’accès à l’énergie est un objectif qui motive et stimule tous nos collaborateurs. À ce titre, nous partageons des valeurs fortes qui guident nos efforts au quotidien. Schneider Electric rime avec :",

          "h2-2": "Who we are and what we do:",
          "h3-1": "Franchise",
          "p-2": "Nous faisons ce que nous disons. Nous l’énonçons clairement. Nous agissons avec intégrité.",

          "h3-2": "Défis",
          "p-3": "Nous relevons les défis, les nôtres et ceux des autres, pour bousculer les façons de penser. Nous sommes ambitieux et nous progressons à la vitesse du changement.",

          "h3-3": "Ouverture",
          "p-4": "Nous prônons la diversité. Nous sommes à l’écoute, curieux, connectés et coopératifs avec l’extérieur.",

          "h3-4": "Passion",
          "p-5": "Nous sommes passionnés par nos clients, nos collaborateurs, nos activités et notre technologie. Nous sommes confiants dans notre capacité à trouver des solutions qui améliorent nos vies.",

          "h3-5": "Efficacité",
          "p-6": "Nous respectons nos engagements. Nous sommes pragmatiques, agiles et nous nous battons pour gagner.",
          "p-7": "En appliquant ces valeurs à nous-mêmes et aux autres jour après jour, nous renforçons notre capacité à innover, nous gagnons en dynamisme et nous sommes mieux armés pour dépasser les attentes des clients."
        },
        "txt2": {
          "h2": "Notre marque employeur",
          "p": "Notre proposition de valeur employeur (EVP) est notre façon de dire au monde ce que signifie l'appartenance à Schneider Electric. Nous sommes une entreprise progressiste : nous pensons qu’il est de notre responsabilité de guider nos collaborateurs sur la voie de la réussite, et de leur fournir les outils nécessaires pour réaliser tout leur potentiel. Notre devise, « Des collaborateurs formidables font de Schneider Electric une entreprise exceptionnelle », se décline en quatre grands principes qui évoluent chaque année. Notre proposition de valeur employeur nous permet de changer la donne grâce à des collaborateurs talentueux et reconnus comme tels, à qui nous garantissons l’égalité des chances, nous faisons confiance et nous donnons les moyens d’innover et de viser l’excellence."
        },
        "table1": {
          "h2": "Des collaborateurs formidables font de Schneider Electric une entreprise exceptionnelle",
          "c1": "Nous croyons que l'accès à l'énergie est une droit humain fondamental.",
          "c1-2": "Pour construire ce futur durable, il nous faut résoudre le paradoxe énergétique.",
          "c2": "Nous offrons à tous nos collaborateurs  les mêmes chances de réussite partout dans le monde.",
          "c2-2": "Nous nous assurons que chacun d'eux se sente unique et donne ce qu'il a de meilleur.",
          "c3": "Nous sommes le leader de la transformation numérique.",
          "c3-2": "Nous collaborons avec l'écosystème le plus large incluant partenaires, intégrateurs et des développeurs et ce, grâce à notre plateforme ouverte.",
          "c4": "Nous sommes ambitieux pour nos clients et pour notre croissance. Nous aimons gagner ensemble.",
          "c4-2": "Nous responsabilisons nos collaborateurs et nous croyons en leur agileté."
        },
        "txt3": {
          "h2": "OneVoice, notre voix",
          "p": "Se sentir entendu, c’est se sentir respecté. Chez Schneider Electric, nous ne partons pas du principe que nous savons ce que pensent nos collaborateurs ou ce qui est le mieux pour eux .  Nous leur posons la question, tous les ans, deux fois par an. Nous ne pouvons pas espérer réussir sans leur apport, donné en toute franchise, et c’est là qu'entre en jeu l’enquête de satisfaction OneVoice. Gérée par un organisme de sondage indépendant, cette enquête mesure avec précision la satisfaction des collaborateurs, et nous permet d’aller de l’avant, collectivement."
        },
        "snapshot": {
          "title": "L’enquête OneVoice en chiffres (fin 2017) :",
          "c1h4": "100%",
          "c1p1": "des salariés sondés",
          "c1p2": "deux fois par an",

          "c2h4": "179 000",
          "c2p1": "e-mails envoyés",

          "c3h4": "78 000",
          "c3p1": "personnes",
          "c3p2": "contactées via les « kiosques » sur 271 sites de production",

          "c4h4": "3 300",
          "c4p1": "managers",
          "c4p2": "ont reçu un rapport dédié",

          "c5h4": "80%",
          "c5unit": "de taux de participation",
          "c5p1": "en 2017,  62 % en 2011"
        },
        "barometer": {
          "h2": "Résultat du baromètre 2015-2017 Planète & Société",
          "cb1": "Santé & Équité",
          "h4": "65.00%",
          "cb2": "affichés par notre Employee Engagement Index",
          "cta": "Voir l’ensemble des résultats"
        }
      }
    }
  }
}
</i18n>
<template>
  <div>
    <Hero
      :loResSrc="require('@/assets/img/our-people/our-people-company-values-hero-lowres.jpg')"
      :hiResSrc="require('@/assets/img/our-people/our-people-company-values-hero.jpg')"
      chapter="04"
      :section="$t('nav.OurPeople')"
      :title="$t('ourPeople.companyValues.hero.title')" />

    <section class="m-b-120 l-section-pad l-bg-white">
      <TxtMedia class="m-b-50">
        <div slot="main-content">
          <h2>{{$t('ourPeople.companyValues.txt1.h2-1')}}</h2>
          <p id="companyvalues">{{$t('ourPeople.companyValues.txt1.p-1')}}</p>
        </div>
        <img slot="sidebar" :src="require('@/assets/img/our-people/JakartaReinhardRoya.jpg')" alt="">
      </TxtMedia>

      <!-- <div class="l-content">
        <div class="row">
          <div class="col-xs-14 col-xs-offset-2">
            <h2 class="t-grey m-b-32">{{$t('ourPeople.companyValues.txt1.h2-2')}}</h2>
          </div>
        </div>
      </div> -->
      <TxtMedia class="m-b-32">
        <div slot="main-content">
          <h3>{{$t('ourPeople.companyValues.txt1.h3-1')}}</h3>
          <p>{{$t('ourPeople.companyValues.txt1.p-2')}}</p>
        </div>
        <img slot="sidebar" :src="require('@/assets/img/our-people/100x100_ICONS_1.png')" alt="">
      </TxtMedia>

      <TxtMedia class="m-b-32">
        <div slot="main-content">
          <h3>{{$t('ourPeople.companyValues.txt1.h3-2')}}</h3>
          <p>{{$t('ourPeople.companyValues.txt1.p-3')}}</p>
        </div>
        <img slot="sidebar" :src="require('@/assets/img/our-people/100x100_ICONS_2.png')" alt="">
      </TxtMedia>

      <TxtMedia class="m-b-32">
        <div slot="main-content">
          <h3>{{$t('ourPeople.companyValues.txt1.h3-3')}}</h3>
          <p>{{$t('ourPeople.companyValues.txt1.p-4')}}</p>
        </div>
        <img slot="sidebar" :src="require('@/assets/img/our-people/100x100_ICONS_3.png')" alt="">
      </TxtMedia>

      <TxtMedia class="m-b-32">
        <div slot="main-content">
          <h3>{{$t('ourPeople.companyValues.txt1.h3-4')}}</h3>
          <p>{{$t('ourPeople.companyValues.txt1.p-5')}}</p>
        </div>
        <img slot="sidebar" :src="require('@/assets/img/our-people/100x100_ICONS_4.png')" alt="">
      </TxtMedia>

      <TxtMedia>
        <div slot="main-content">
          <h3>{{$t('ourPeople.companyValues.txt1.h3-5')}}</h3>
          <p>{{$t('ourPeople.companyValues.txt1.p-6')}}</p>
        </div>
        <img slot="sidebar" :src="require('@/assets/img/our-people/100x100_ICONS_5.png')" alt="">
      </TxtMedia>
    </section>

    <section class="m-t-120 m-b-120">
      <TxtMedia>
        <div slot="main-content">
          <h2>{{$t('ourPeople.companyValues.txt2.h2')}}</h2>
          <p id="companyevp">{{$t('ourPeople.companyValues.txt2.p')}}</p>
        </div>
        <img slot="sidebar" :src="require('@/assets/img/our-people/our-people-company-values-full-img.jpg')" alt="">
      </TxtMedia>
    </section>

    <section class="m-t-120 m-b-120 l-section-pad l-bg-white">
      <FourCols>
        <div slot="above">
          <h2>{{$t('ourPeople.companyValues.table1.h2')}}</h2>
        </div>
        <FourColsItem>
          <img class="img-responsive" :src="require('@/assets/img/our-people/our-people-company-values-grid-1.jpg')" alt=""/>
          <p class="" v-html="$t('ourPeople.companyValues.table1.c1')"></p>
          <p class="" v-html="$t('ourPeople.companyValues.table1.c1-2')"></p>
        </FourColsItem>
        <FourColsItem>
          <img class="img-responsive" :src="require('@/assets/img/our-people/our-people-company-values-grid-2.jpg')" alt=""/>
          <p class="" v-html="$t('ourPeople.companyValues.table1.c2')"></p>
          <p class="" v-html="$t('ourPeople.companyValues.table1.c2-2')"></p>
        </FourColsItem>
        <FourColsItem>
          <img class="img-responsive" :src="require('@/assets/img/our-people/our-people-company-values-grid-3.jpg')" alt=""/>
          <p class="" v-html="$t('ourPeople.companyValues.table1.c3')"></p>
          <p class="" v-html="$t('ourPeople.companyValues.table1.c3-2')"></p>
        </FourColsItem>
        <FourColsItem>
          <img class="img-responsive" :src="require('@/assets/img/our-people/our-people-company-values-grid-4.jpg')" alt=""/>
          <p class="" v-html="$t('ourPeople.companyValues.table1.c4')"></p>
          <p class="" v-html="$t('ourPeople.companyValues.table1.c4-2')"></p>
        </FourColsItem>
      </FourCols>
    </section>

    <section class="m-t-120 m-b-120">
      <TxtMedia>
        <div slot="main-content">
          <h2>{{$t('ourPeople.companyValues.txt3.h2')}}</h2>
          <p id="onevoice">{{$t('ourPeople.companyValues.txt3.p')}}</p>
        </div>
        <img slot="sidebar" :src="require('@/assets/img/our-people/SydneySharonMishra.jpg')" alt="">
      </TxtMedia>
    </section>

    <hr>

    <section class="m-t-120 m-b-120">
      <Snapshot>
        <div slot="above">
          <h2 id="onevoiceresults">{{$t('ourPeople.companyValues.snapshot.title')}}</h2>
        </div>
        <SnapshotCard class="t-white" bgc="#3dcd58">
          <h4 class="">{{$t('ourPeople.companyValues.snapshot.c1h4')}}</h4>
          <p class="t-chartbody">{{$t('ourPeople.companyValues.snapshot.c1p1')}}</p>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody">{{$t('ourPeople.companyValues.snapshot.c1p2')}}</p>
        </SnapshotCard>

        <SnapshotCard class="minheight no-overlay" :double="true" :bgimg="require('@/assets/img/our-people/SingaporeYuSiangChieng.jpg')">
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#626469">
          <h4 class="">{{$t('ourPeople.companyValues.snapshot.c4h4')}}</h4>
          <p class="t-chartbody">{{$t('ourPeople.companyValues.snapshot.c4p1')}}</p>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody">{{$t('ourPeople.companyValues.snapshot.c4p2')}}</p>
        </SnapshotCard>

        <SnapshotCard :double="true">
          <h4 class="t-green-light" v-html="$t('ourPeople.companyValues.snapshot.c5h4')"></h4>
          <p class="t-green-light" v-html="$t('ourPeople.companyValues.snapshot.c5unit')"></p>
          <div class="t-hr"></div>
          <p v-html="$t('ourPeople.companyValues.snapshot.c5p1')"></p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#626469">
          <h4 class="">{{$t('ourPeople.companyValues.snapshot.c2h4')}}</h4>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody">{{$t('ourPeople.companyValues.snapshot.c2p1')}}</p>
        </SnapshotCard>

        <SnapshotCard class="t-white" bgc="#3dcd58">
          <h4 class="">{{$t('ourPeople.companyValues.snapshot.c3h4')}}</h4>
          <p class="t-chartbody">{{$t('ourPeople.companyValues.snapshot.c3p1')}}</p>
          <div class="t-hr t-hr--white"></div>
          <p class="t-chartbody">{{$t('ourPeople.companyValues.snapshot.c3p2')}}</p>
        </SnapshotCard>
      </Snapshot>
    </section>

    <hr>

    <section class="m-t-120 m-b-120">
      <Barometer>
        <h2 class="t-grey" slot="copy" v-html="$t('ourPeople.companyValues.barometer.h2')"></h2>
        <CTA class="m-4" slot="copy" href="/static/PSBarometer-Q42017_results.pdf" :buttonText="$t('ourPeople.companyValues.barometer.cta')" target="_blank"/>
        <BarometerIndicator class="col-xs-18" color="#42b4e6" :title="$t('ourPeople.companyValues.barometer.cb1')" stat="65%" :body="$t('ourPeople.companyValues.barometer.cb2')" />
      </Barometer>
    </section>

    <div class="l-content">
      <FooterNav
        nextRoute="OurPeople_CompanyPrograms"
        prevRoute="OurPeople_Overview" />
    </div>
  </div>
</template>
<script>
import Hero from '@/components/Hero'
import FooterNav from '@/components/FooterNav'
import Txt from '@/components/Txt'
import ImageFull from '@/components/ImageFull'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import Snapshot from '@/components/Snapshot'
import SnapshotCard from '@/components/SnapshotCard'
import Barometer from '@/components/Barometer'
import BarometerIndicator from '@/components/BarometerIndicator'
import CTA from '@/components/CTA'
import TxtMedia from '@/components/TxtMedia'

export default {
  name: 'OurPeople_CompanyValues',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    Hero,
    FooterNav,
    Txt,
    ImageFull,
    FourCols,
    FourColsItem,
    Snapshot,
    SnapshotCard,
    Barometer,
    BarometerIndicator,
    CTA,
    TxtMedia
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/our-people/company-values.vue